import { render, staticRenderFns } from "./DailyExpense.vue?vue&type=template&id=151a5c27&"
import script from "./DailyExpense.vue?vue&type=script&lang=js&"
export * from "./DailyExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports